import {createAction, props} from "@ngrx/store";
import {Ship} from "../../models/Ship";

export const UPDATE = '[Ships] Update';
export const REFRESH = '[Ships] Refresh';
export const update = createAction(UPDATE, props<{ ships: Ship[] }>());
export const refresh = createAction(REFRESH);
